import cx from 'classnames';

type OwnProps = {
  className?: string;
};

export default function Halo({ className }: OwnProps) {
  return <div className={cx('h-[4px] w-[30px] bg-yellow-2', className)} />;
}
